import { ITextLocaleMap } from '../models/workflows.models';

/**
 * Obtiene un string por ruta con puntos desde el objeto JSON de traducciones cargado en runtime.
 */
export function pickStringFromTranslationBundle(bundle: unknown, path: string): string {
	const parts = path.split('.');
	let cur: unknown = bundle;
	for (const p of parts) {
		if (cur == null || typeof cur !== 'object') {
			return '';
		}
		cur = (cur as Record<string, unknown>)[p];
	}
	return typeof cur === 'string' ? cur : '';
}

/**
 * Construye un mapa locale→texto para los idiomas permitidos usando bundles dinámicos por idioma;
 * idiomas sin entrada en su JSON usan fallback en español (si existe).
 */
export function buildLocaleMapFromTranslationBundles(
	allowedLocales: readonly string[],
	path: string,
	bundlesByLocale: Readonly<Record<string, unknown>>,
): ITextLocaleMap {
	const esFallback = pickStringFromTranslationBundle(bundlesByLocale['es'], path);
	const out: ITextLocaleMap = {};
	for (const l of allowedLocales) {
		const localeValue = pickStringFromTranslationBundle(bundlesByLocale[l], path);
		out[l] = localeValue || esFallback;
	}
	return out;
}
